import { Components as WppComponentTypes } from '@wppopen/components-library/dist/types/components'
import { WppGrid, WppSkeleton } from '@wppopen/components-library-react'

interface AsyncContentBlockProps extends Partial<WppComponentTypes.WppGrid> {
  height?: number
}

const AsyncContentBlock = ({ height, ...props }: AsyncContentBlockProps) => {
  return (
    <WppGrid item all={props.all} fullHeight fullWidth data-testid="content-block-skeleton-container">
      <WppSkeleton
        variant="rectangle"
        height={height}
        style={{ width: '100%', height: height ? '' : '100%' }}
        data-testid="content-block-skeleton"
      />
    </WppGrid>
  )
}

export default AsyncContentBlock
